import type { Recurrence, SavedFile, TaskDetail } from '@frontend/api-types';
import { makeSavedFileList } from '@frontend/forms';
import { useState } from '@frontend/react';
import { useVisibilityController } from '@frontend/react/hooks';
import { FilePreviewModal, Modal, YStack, type CommonModalProps } from '@frontend/web-react';
import { DetailItemContainer } from '@frontend/web/components/DomainSpecific/Tasks/TaskDetailModal/DetailItemContainer';
import { ChatFilePreview } from './Chat/ChatFilePreview';

export type TaskAttachmentModalProps = CommonModalProps & {
  recurrence?: Recurrence;
  task?: TaskDetail;
};

export const TaskAttachmentModal = ({ isOpen, onClose, recurrence, task }: TaskAttachmentModalProps) => {
  const isRecurrence = !!recurrence;
  const detail = isRecurrence ? recurrence : task;
  const [selectedAttachment, setSelectedAttachment] = useState<SavedFile>();
  const [isFilePreviewModalOpen, { close: closeFilePreviewModal, open: openFilePreviewModal }] =
    useVisibilityController();

  const savedAttachments = makeSavedFileList(detail?.attachments ?? [], (a) => ({
    ...a,
    key: a.fileName,
    url: a.contentUrl,
  }));

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      {detail?.attachments?.length ? (
        <DetailItemContainer title={`Attachments (${detail.attachments.length})`}>
          <YStack gap="sm">
            {savedAttachments.map((attachment) => (
              <ChatFilePreview
                file={attachment}
                key={attachment.key}
                onClick={(file) => {
                  setSelectedAttachment(file);
                  openFilePreviewModal();
                }}
              />
            ))}
          </YStack>
        </DetailItemContainer>
      ) : null}
      <FilePreviewModal
        file={selectedAttachment}
        isOpen={isFilePreviewModalOpen}
        onClose={closeFilePreviewModal}
        title={selectedAttachment?.key}
      />
    </Modal>
  );
};
